"use client";

import { createContext, useContext, type ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useAdminProductsAttentionCount } from "@/lib/hooks/useAdminProductsAttentionCount";

type AdminProductsAttentionContextType = {
  count: number;
  isLoading: boolean;
  refresh: () => Promise<void>;
};

const defaultValue: AdminProductsAttentionContextType = {
  count: 0,
  isLoading: false,
  refresh: async () => {},
};

const AdminProductsAttentionContext =
  createContext<AdminProductsAttentionContextType>(defaultValue);

export function AdminProductsAttentionProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { isAdmin } = useAuth();
  const attention = useAdminProductsAttentionCount({
    enabled: isAdmin,
  });

  return (
    <AdminProductsAttentionContext.Provider value={attention}>
      {children}
    </AdminProductsAttentionContext.Provider>
  );
}

export function useAdminProductsAttentionContext() {
  return useContext(AdminProductsAttentionContext);
}
